import { actionCreator } from '@ardoq/rxbeach';
import { ViewSidePanelContentIds } from './types';

export const showViewSidePanel = actionCreator<ViewSidePanelContentIds>(
  '[SIDE_PANEL] OPEN_SIDE_PANEL'
);
export const hideViewSidePanel = actionCreator('[SIDE_PANEL] CLOSE_SIDE_PANEL');
